var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.005 3H3.995A.995.995 0 003 3.995v16.01a.994.994 0 00.995.995h8.62v-6.947h-2.352v-2.738h2.34v-2c0-2.327 1.418-3.593 3.493-3.593.705.002 1.409.042 2.11.12v2.429h-1.434c-1.128 0-1.346.533-1.346 1.32v1.736h2.7l-.35 2.726h-2.35V21h4.58a.994.994 0 00.994-.995V3.995A.995.995 0 0020.005 3z",
    fill: "#ACB5BD"
  })));
}

export default SvgFacebook;